export default "__VITE_ASSET__C2NCu48___"